import TruthLens from "./Angle";

export default function App() {
  return <TruthLens />;
}
